export default "__VITE_ASSET__r5BoE09$__"